import FinanceAdapter from './base';

export default class StripeConnection extends FinanceAdapter {
  modelNamePlural = 'stripeConnections';
}
